"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingPriceByLocality$ = exports.ListingPriceByLocality$outboundSchema = exports.ListingPriceByLocality$inboundSchema = void 0;
exports.listingPriceByLocalityToJSON = listingPriceByLocalityToJSON;
exports.listingPriceByLocalityFromJSON = listingPriceByLocalityFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const fastapikrakenendpointsstatsmodelslettingslocalauthoritygetlistingpriceresponseslistingprice_js_1 = require("./fastapikrakenendpointsstatsmodelslettingslocalauthoritygetlistingpriceresponseslistingprice.js");
/** @internal */
exports.ListingPriceByLocality$inboundSchema = z.object({
    stats: z.array(fastapikrakenendpointsstatsmodelslettingslocalauthoritygetlistingpriceresponseslistingprice_js_1.FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$inboundSchema),
});
/** @internal */
exports.ListingPriceByLocality$outboundSchema = z.object({
    stats: z.array(fastapikrakenendpointsstatsmodelslettingslocalauthoritygetlistingpriceresponseslistingprice_js_1.FastapiKrakenEndpointsStatsModelsLettingsLocalAuthorityGetListingPriceResponsesListingPrice$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ListingPriceByLocality$;
(function (ListingPriceByLocality$) {
    /** @deprecated use `ListingPriceByLocality$inboundSchema` instead. */
    ListingPriceByLocality$.inboundSchema = exports.ListingPriceByLocality$inboundSchema;
    /** @deprecated use `ListingPriceByLocality$outboundSchema` instead. */
    ListingPriceByLocality$.outboundSchema = exports.ListingPriceByLocality$outboundSchema;
})(ListingPriceByLocality$ || (exports.ListingPriceByLocality$ = ListingPriceByLocality$ = {}));
function listingPriceByLocalityToJSON(listingPriceByLocality) {
    return JSON.stringify(exports.ListingPriceByLocality$outboundSchema.parse(listingPriceByLocality));
}
function listingPriceByLocalityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ListingPriceByLocality$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ListingPriceByLocality' from JSON`);
}
//# sourceMappingURL=listingpricebylocality.js.map